<template>
  <div>
    <div class="text-h6">
      {{ $t('components.transfer.assignedPixels.headline') }}
    </div>
    <div class="body-2">
      <span>{{ $t('components.transfer.assignedPixels.info') }}</span>
      <v-list two-line>
        <v-list-item
          v-for="pixel in transfer.assignedPixels"
          :key="pixel.id"
          @click="showPixelDialog(pixel.id)"
        >
          <v-list-item-action>
            <v-icon color="info"> mdi-memory </v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ pixel.title }}</v-list-item-title>
            <v-list-item-subtitle>
              {{ $t('components.transfer.assignedPixels.triggered') }}:
              {{ pixel.triggered }}
              - {{ $t('components.transfer.assignedPixels.approved') }}:
              {{
                pixel.approved
                  ? $t('components.transfer.assignedPixels.yes')
                  : $t('components.transfer.assignedPixels.no')
              }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState('transfer', ['transfer']),
  },
  watch: {},
  mounted() {},
  methods: {
    showPixelDialog(id) {
      this.$bus.fire('show-pixel-dialog', id);
    },
  },
};
</script>

<style></style>
